<h2 mat-dialog-title>Share View: {{ data.tab.name }}</h2>

<mat-dialog-content class="share-view">
  <div class="share-view__email">
    <mat-form-field>
      <mat-label>User email</mat-label>
      <input matInput [formControl]="emailControl" />
    </mat-form-field>
    @if (validating) {
      <button mat-stroked-button disabled>
        <mat-icon>
          <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
        </mat-icon>
        Validating
      </button>
    } @else {
      <button mat-stroked-button [disabled]="!emailControl.value" (click)="validate()">Validate view</button>
    }
  </div>
  @if (validated) {
    @if (userFound) {
      <div class="share-view__user-found">
        <mat-icon class="material-icons-outlined">person</mat-icon>
        User found
      </div>
    } @else {
      <div class="share-view__user-not-found">
        <mat-icon class="material-icons-outlined">person</mat-icon>
        User not found
      </div>
    }
  }

  @if (tabExists) {
    <div class="share-view__override">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      The view with this name already exists for the user. Sharing this view will override the existing one.
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="action-buttons">
  <button mat-stroked-button matDialogClose>Cancel</button>
  @if (sharing) {
    <button mat-flat-button disabled>
      <mat-icon>
        <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
      </mat-icon>
      Sharing
    </button>
  } @else {
    <button mat-flat-button (click)="share()" [disabled]="!userFound">Share view</button>
  }
</mat-dialog-actions>
